import { axiosApiInstance, headers, multipart_headers } from './_httpHeaders';

// U015. 서비스 이용현황 조회
export const getUsageStusList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectUsageStusList_v2.do`,
    params: {
      searchText: reqParam.searchText,
    },
  });

// U016. 이용 서비스 신청하기
export const insertUsageStus = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertUsageStus.do`,
    data: {
      resultList: dataParam.resultList,
    },
  });

// U017. 서비스 신청된 리스트 사이드 조회
export const getUsageSideList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectUsageSideList.do`,
    params: {
      rcptGroupCode: reqParam.rcptGroupCode,
      CSvcEngine: reqParam.CSvcEngine,
      gubun: reqParam.gubun,
    },
  });

// U018. 이용 서비스 임시저장
export const insertAcntUsageInfo = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertAcntUsageInfo.do`,
    data: {
      btnStatus: dataParam.btnStatus,
      rcptSeq: dataParam.rcptSeq,
      colctCycle: dataParam.colctCycle,
      dpcltDelYn: dataParam.dpcltDelYn,
      colctTime: dataParam.colctTime,
      rcptGroupCode: dataParam.rcptGroupCode,
      acntlist: dataParam.acntlist,
    },
  });

// U019.  이용서비스 접수
export const updateRcptInfo = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/updateRcptInfo.do`,
    data: {
      btnStatus: dataParam.btnStatus,
      rcptGroupCode: dataParam.rcptGroupCode,
      rcptBgngYmd: dataParam.rcptBgngYmd,
      rcptStopYmd: dataParam.rcptStopYmd,
      resultList: dataParam.resultList,
      deleteList: dataParam.deleteList,
      saveList: dataParam.saveList,
    },
  });

// U020. 업체 서비스 상세 조회
export const getUsageDetailInfo = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectUsageDetailInfo.do`,
    params: {
      btnStatus: reqParam.btnStatus,
      rcptSeq: reqParam.rcptSeq,
    },
  });

// U021. 이용서비스 수정버튼 클릭시 (이용서비스 변경 및 수정에서 저장)
export const saveAcntUsageInfo = (dataParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/saveAcntUsageInfo.do`,
    data: {
      svcList: dataParam.svcList,
      delList: dataParam.delList, // [rcpSeq,]
    },
  });

// U022. 해지,이용중지
export const insertRcptStopInfo = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertRcptStopInfo.do`,
    data: {
      btnStatus: dataParam.btnStatus,
      rcptSeq: dataParam.rcptSeq,
      CSvcEngine: dataParam.CSvcEngine,
      usCode: dataParam.usCode,
      rcptStopYmd: dataParam.rcptStopYmd,
      resultList: dataParam.resultList, // [dsrbtrCode, ]
    },
  });

// U023. 서비스 변경 요청
export const insertTransStusInfo = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertTransStusInfo.do`,
    data: {
      dsrbtrCode: dataParam.dsrbtrCode,
      CSvcEngine: dataParam.CSvcEngine,
      strgType: dataParam.strgType,
      rcptAcntType: dataParam.rcptAcntType,
      colctCycle: dataParam.colctCycle,
      dpcltDelYn: dataParam.dpcltDelYn,
      colctTime: dataParam.colctTime,
      usCode: dataParam.usCode,
      btnStatus: dataParam.btnStatus,
      resultList: dataParam.resultList, // [dsrbtrCode, ]
      acntlist: dataParam.acntlist,
    },
  });

// U024. 업체 서비스 신청 상태코드 조회(목록화면 검색조건)
export const getUsageCodeList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectUsageCodeList.do`,
  });

// U025. 신청 취소
export const updateCancelRcpt = (dataParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/updateCancelRcpt.do`,
    data: {
      resultList: dataParam, //[rcptGroupSeq, ]
    },
  });

// U026. 해당업체의 문서 코드 조회 (등록 수정 화면에서 사용)
export const getDocUseList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectDocUseList.do`,
    params: {
      rcptSeq: reqParam.rcptSeq,
      dsrbtrCode: reqParam.dsrbtrCode,
    },
  });

// U027. 서비스 신청 그룹 목록 조회
export const getUsageList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectUsageList.do`,
    params: {
      checkDate: reqParam.checkDate === 0 ? null : reqParam.checkDate,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      dsrbtrCode: reqParam.dsrbtrCode,
      srsCode: reqParam.srsCode,
      spsCode: reqParam.spsCode,
      srtCode: reqParam.srtCode,
      searchText: reqParam.searchText,
      searchGubun: reqParam.searchGubun, // 값 1 신청일, 2 처리일 (ADMIN)에서사용
      page: reqParam.pageStart, // 어떻게 되는지 문의
      perPageNum: reqParam.perPageNum,
    },
  });

// U027. 서비스 신청 그룹 목록 엑셀다운로드
export const excelUsageList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectUsageListExcel.do`,
    params: {
      checkDate: reqParam.checkDate === 0 ? null : reqParam.checkDate,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      dsrbtrCode: reqParam.dsrbtrCode,
      srsCode: reqParam.srsCode,
      spsCode: reqParam.spsCode,
      srtCode: reqParam.srtCode,
      searchText: reqParam.searchText,
      searchGubun: reqParam.searchGubun, // 값 1 신청일, 2 처리일 (ADMIN)에서사
      downLoad: 'Y', //y일 시 다운로드!
    },
  });

// U028. ADMIN 처리내역 수정
export const insertPrcsInfo = (dataParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/servicemngt/insertPrcsInfo.do`,
    data: {
      rcptGroupSeq: dataParam.rcptGroupSeq,
      cAdCo: dataParam.cAdCo,
      prcsDc: dataParam.prcsDc,
      testStartYmd: dataParam.testStartYmd,
      testEndYmd: dataParam.testEndYmd,
      bgngSchdulYmd: dataParam.bgngSchdulYmd,
      cPrcsStatus: dataParam.cPrcsStatus,
    },
  });

// U029. 이용현황 조회(ADMIN)
export const getAdminUseList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/servicemngt/selectAdminUseList.do`,
    params: {
      checkDate: reqParam.checkDate,
      startDt: reqParam.startDt,
      endDt: reqParam.endDt,
      dsrbtrCode: reqParam.dsrbtrCode,
      searchText: reqParam.searchText,
      searchGubun: reqParam.searchGubun,
    },
  });

// U030. ADMIN 목록에서 처리완료,접수 취소
export const insertListPrcsInfo = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/servicemngt/insertListPrcsInfo.do`,
    data: {
      rcptGroupSeq: dataParam.rcptGroupSeq,
      cPrcsStatus: dataParam.cAdCo,
      dsrbtrCode: dataParam.prcsDc,
      usCode: dataParam.testStartYmd,
    },
  });

// U3420. 수신자 그룹등록
export const insertRcvGroupInfo = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertRcvGroupInfo.do`,
    data: {
      ntcnGrpNm: dataParam.ntcnGrpNm,
      ntcnGrpDc: dataParam.ntcnGrpDc,
      grpUseYn: 1,
      resultList: dataParam.resultList,
      /*
    resultList: [{
      ntcnGrmbrId
    },]
    */
    },
  });

// U3402. 회원사 회원 목록 조회
export const getRecvList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectRecvList.do`,
    params: {
      ntcnGrpSeq: reqParam.ntcnGrpSeq,
    },
  });

// U3401. 등록된 그룹목록조회 (수신 그룹 목록 조회)
export const getRevGroupList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectRevGroupList.do`,
    params: {
      ntcnGrpSeq: reqParam.ntcnGrpSeq,
      grpUseYn: 1,
      pageStart: reqParam.pageStart ? reqParam.pageStart : 0,
      perPageNum: reqParam.perPageNum ? reqParam.perPageNum : 20,
    },
  });

// U3400. 알람서비스 검색조건 그룹 목록 콤보박스
export const getGrpNmList = (useYn) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectGrpNmList.do`,
    params: {
      grpUseYn: useYn,
    },
  });

// U3440. 수신자 그룹수정
export const saveRcvGroupInfo = (dataParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/saveRcvGroupInfo.do`,
    data: {
      ntcnGrpNm: dataParam.ntcnGrpNm,
      ntcnGrpDc: dataParam.ntcnGrpDc,
      grpUseYn: 1,
      ntcnGrpSeq: dataParam.ntcnGrpSeq,
      resultList: dataParam.resultList,
    },
  });

// U3460. 수신자 그룹삭제
export const deleteRcvGroupInfo = (dataParam) =>
  axiosApiInstance({
    method: 'delete',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/deleteRcvGroupInfo.do`,
    data: {
      resultList: dataParam,
    },
  });

// U3403. 알람서비스 알림업무 콤보 리스트
export const getSysMlist = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectSysMlist.do`,
  });

// U057. 상품코드 목록 조회
export const getTusCodeL = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectTusCodeL.do`,
    params: {
      pageStart: reqParam.pageStart,
      readCount: reqParam.perPageNum,
      dsrbtrCode: reqParam.ds,
      codeType: reqParam.tp,
      usCodeSearch: reqParam.usCodeSearch,
    },
  });

//U2604. 상품코드 엑셀 다운로드
export const downloadTusCodeExcel = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/downloadTusCodeExcel.do`,
    responseType: 'arraybuffer',
    params: {
      dsrbtrCode: reqParam.ds,
      codeType: reqParam.tp,
      usCodeSearch: reqParam.usCodeSearch,
    },
  });

// U058. 상품코드 상세 조회
export const getTusCodeLDetail = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectTusCodeLDetail.do`,
    params: {
      usCodeSeq: reqParam.usCodeSeq,
    },
  });

// U059. 코드타입, 유통코드 조회
export const getDsbtrList = (usCodeSeq) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectDsbtrList.do`,
    params: {
      usCodeSeq: usCodeSeq === undefined ? null : usCodeSeq,
    },
  });

// U060. 상품코드 삭제
export const deleteTusCodeL = (dataParam) =>
  axiosApiInstance({
    method: 'delete',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/deleteTusCodeL.do`,
    data: {
      dataList: dataParam.dataList,
      // dataParam.dataList: [{usCodeSeq,},]
    },
  });

// U061. 상품코드 수정
export const updateTusCodeL = (dataParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/updateTusCodeL.do`,
    data: {
      data: dataParam.data,
    },
  });

// U062. 상품코드 다건등록
export const insertTusCodeExcel = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertTusCodeExcel.do`,
    data: dataParam,
    // file: dataParam.file, // "xls", "xlsx" 두가지 포맷방식만 지원함
  });

// U063. 상품코드 등록
export const insertTusCodeL = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertTusCodeL.do`,
    data: {
      dataList: dataParam.dataList,
    },
  });

// U064. Excell 파일 데이터 검수
export const checkExcelFile = (file) =>
  axiosApiInstance({
    method: 'post',
    headers: multipart_headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/checkExcellFile.do`,
    data: file, // "xls", "xlsx" 두가지 포맷방식만 지원함
  });

// U065. 알람서비스 2번쨰탭 수신자 삭제(수정화면에서)
export const deleteRcvInfo = (dataParam) =>
  axiosApiInstance({
    method: 'delete',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/deleteRcvInfo.do`,
    data: {
      resultList: dataParam.resultList,
      // dataParam.resultList: [{ntcnGrmbrSeq,},]
    },
  });

// U3442. 알림서비스 수신자관리 등록
export const insertAlarmMngt = (dataParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/insertAlramMngt.do`,
    data: {
      ntcnSvcCode: dataParam.ntcnSvcCode,
      dutyTypeCode: dataParam.dutyTypeCode,
      resultList: dataParam.ntcnGrpSeq,
      ntcnUseYn: dataParam.ntcnUseYn,
      smsUseYn: dataParam.smsUseYn === null ? 0 : dataParam.smsUseYn,
      emailUseYn: dataParam.emailUseYn === null ? 0 : dataParam.emailUseYn,
      ntcnPermDay: dataParam.ntcnPermDay,
      ntcnPermTime: dataParam.ntcnPermTime,
      ntcnPermDc: dataParam.ntcnPermDc,
      ntcnDc: dataParam.ntcnDc,
    },
  });

// U3406. 알람서비스 3번쨰탭 알림관리 상세 조회
export const getAlramDetail = (ntcnCode) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectArlamDetail.do`,
    params: {
      ntcnCode: ntcnCode,
    },
  });

// U3441. 알람서비스 3번쨰탭 알림설정수정
export const saveAlramMngt = (dataParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/saveAlramMngt.do`,
    data: {
      ntcnSvcCode: dataParam.ntcnSvcCode,
      dutyTypeCode: dataParam.dutyTypeCode,
      ntcnCode: dataParam.ntcnCode,
      ntcnUseYn: dataParam.ntcnUseYn,
      smsUseYn: dataParam.smsUseYn,
      emailUseYn: dataParam.emailUseYn,
      ntcnPermDay: dataParam.ntcnPermDay,
      ntcnPermTime: dataParam.ntcnPermTime,
      ntcnPermDc: dataParam.ntcnPermDc,
      accmltPrcsType: '1',
      resultList: dataParam.grpList, // ntctnGrpSeq, ntcnGrpNm
      ntcnDc: dataParam.ntcnDc,
    },
  });

// U3461. 알람서비스 3번쨰탭 알람 삭제
export const deleteNtcnInfo = (dataParam) =>
  axiosApiInstance({
    method: 'delete',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/deleteNtcnInfo.do`,
    data: {
      resultList: dataParam,
      // dataParam.resultList: [{ntcnCode, ntcnSeq,},]
    },
  });

// U3404. 알람서비스 3번쨰탭 알림관리 목록조회
export const getNtcnList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectNtcnList.do`,
    params: {
      ntcnDutyCode: reqParam.ntcnDutyCode,
      ntcnSvcCode: reqParam.ntcnSvcCode,
      ntcnUseYn: reqParam.ntcnUseYn === null || reqParam.ntcnUseYn === '' ? null : +reqParam.ntcnUseYn,
      smsUseYn: reqParam.entireUseYn === 1 ? null : reqParam.smsUseYn,
      emailUseYn: reqParam.entireUseYn === 1 ? null : reqParam.emailUseYn,
      ntcnPermTime: reqParam.ntcnPermTime,
      ntcnPermDay: reqParam.ntcnPermDay,
      ntcnGrpNm: reqParam.ntcnGrpNm === '전체' ? '' : reqParam.ntcnGrpNm,
      searchText: reqParam.searchText,
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
    },
  });

// U079. 알람서비스 알람 상세에서 삭제시 모두삭제
export const deleteRcvInfoAll = (reqParam) =>
  axiosApiInstance({
    method: 'delete',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/deleteRcvInfoAll.do`,
    data: {
      ...reqParam,
    },
  });

// U080. 서비스 변경 시, 그룹코드 생성 및 서비스데이터 복사 저장 - 접수 X
export const updateUsageStus = (rcptSeq) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/updateUsageStus.do`,
    data: {
      rcptSeq: rcptSeq,
    },
  });

// U081. 온라인 연계 몰 리스트
export const getMallList = (dsrbtrCode) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectMallList.do`,
    params: {
      dsrbtrCode: dsrbtrCode,
    },
  });

// U024. 서비스관리 이용현황 이용중인 요금제 보기
export const selectFeeInfo = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/selectFeeInfo.do`,
  });

// U5122. 동일 유통사 내 VanId 중복 체크
export const chkOverLapVanId = (reqParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicemngt/chkOverLapVanId.do`,
    data: {
      dsrbtrCode: reqParam.dsrbtrCode,
      vanIds: reqParam.vanIds,
      rcptSeq: reqParam.rcptSeq,
    },
  });
